import styled, { css } from 'styled-components'
import { Utils, colors } from '@microfrontends/react-components'

export const JobListWrapper = styled.div``

export const JobListHeader = styled.div<{ isMobile: boolean }>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    ${({ isMobile }) =>
        isMobile &&
        css`
            flex-direction: column;
            align-items: stretch;
            gap: 8px;
        `}
`

export const JobListTitle = styled.h2`
    margin-bottom: 0px !important;
    align-items: center;
    display: flex;
    font-size: 18px !important;
    font-weight: 600 !important;
    line-height: 22px !important;
`

export const JobAmount = styled.div`
    color: ${colors.grey[60]};
    font-size: 16px;
    line-height: 20px;
    font-weight: 500;
    display: flex;

    @media screen and (max-width: ${Utils.screens.mobile}px) {
        font-size: 15px;
    }
`

export const JobListFilters = styled.div<{ isMobile: boolean }>`
    display: flex;
    align-items: center;
    width: ${({ isMobile }) => (isMobile ? '100%' : '400px')};
`

export const SearchRemoveIcon = styled.div<{ isDisplay?: boolean }>`
    display: inline-grid;
    pointer-events: ${({ isDisplay }) => (isDisplay ? 'all' : 'none')};
    position: absolute;
    top: 50%;
    right: 8px;
    transform: translateY(-50%);
    z-index: 1;
    opacity: 0;
    transition: 0.25s;
    cursor: pointer;
`

export const SearchBox = styled.div<{ isDisplayRemoveIcon?: boolean }>`
    position: relative;
    padding: 8px;
    border-radius: 6px;
    background-color: #f4f4f7;
    display: flex;
    align-items: center;
    height: 40px;
    flex: 1;

    &:hover ${SearchRemoveIcon} {
        opacity: ${({ isDisplayRemoveIcon }) => (isDisplayRemoveIcon ? 0.5 : 0)};
        :hover {
            opacity: 1;
        }
    }
`

export const SearchInput = styled.input<{ isDisplayRemoveIcon?: boolean }>`
    font-size: 14px;
    line-height: 16px;
    margin-left: 8px;
    padding-right: 24px;
    background-color: transparent;
    outline: none;
    border: none;
    width: 100%;

    &:focus ~ ${SearchRemoveIcon} {
        opacity: ${({ isDisplayRemoveIcon }) => (isDisplayRemoveIcon ? 0.5 : 0)};
    }
`

export const ImageWrapper = styled.div`
    width: 184px;
    height: 80px;
    position: relative;
    display: inline-block;
`

export const ButtonWrapper = styled.div<{ isMobile: boolean }>`
    text-align: center;
    padding-top: 10px;
    padding-bottom: ${({ isMobile }) => (isMobile ? '10px' : 0)};
`

export const JobCardWrapper = styled.div`
    display: grid;
    row-gap: 8px;
`
